import React from "react";
// import Swiper core and required modules
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  Autoplay,
  EffectFade,
  Navigation,
  Pagination,
} from "swiper";

SwiperCore.use([Navigation, Pagination, EffectFade, Autoplay]);
function TestimonialArea() {
  const testimonialSlider = {
    slidesPerView: 1,
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };
  return (
    <>
      <section className="testimonial-area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="swiper testimonial-slider">
                <Swiper
                  pagination={{
                    type: "fraction",
                  }}
                  {...testimonialSlider}
                  className="swiper-wrapper"
                >
                  <SwiperSlide className="swiper-slide">
                    <div className="testimonial-content">
                      <div className="quote">
                        <i className="fas fa-quote-left" />
                      </div>
                      <div className="client-info">
                        <div className="client-pic">
                          <img
                            src={process.env.PUBLIC_URL + "/images/AkshayJain.png"}
                            alt="images"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Akshay Jain</h4>
                          <span>Founder</span>
                        </div>
                      </div>
                      <p>
                        <i className="fas fa-quote-left" />  Gybits did an excellent job designing and developing the Workleisure website. 
                        The design is clean, modern, and perfectly aligned with our brand identity. 
                        Their team understood our requirements clearly and delivered a fast, 
                        responsive website with great attention to detail.{" "}
                        <i className="fas fa-quote-right" />
                      </p>
                      <div className="rating">
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <div className="testimonial-content">
                      <div className="quote">
                        <i className="fas fa-quote-left" />
                      </div>
                      <div className="client-info">
                        <div className="client-pic">
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/DigvijaySingh.png"
                            }
                            alt="images"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Digvijay Singh</h4>
                          <span>Cafe Owner</span>
                        </div>
                      </div>
                      <p>
                        <i className="fas fa-quote-left" />  Gybits did an amazing job designing our café website. The look and feel 
                        perfectly capture our brand and atmosphere. The site is clean, fast, and 
                        easy for our customers to navigate, which has helped us create a stronger 
                        online presence. {" "}
                        <i className="fas fa-quote-right" />
                      </p>
                      <div className="rating">
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <div className="testimonial-content">
                      <div className="quote">
                        <i className="fas fa-quote-left" />
                      </div>
                      <div className="client-info">
                        <div className="client-pic">
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/ShubhamManana.png"
                            }
                            alt="images"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Shubham Manana</h4>
                          <span>Furtniture Business Owner</span>
                        </div>
                      </div>
                      <p>
                        <i className="fas fa-quote-left" />Partnering with Gybits to develop our website and application has been a fantastic experience. Their team understood our vision and delivered a user-friendly, beautiful website that perfectly represents our brand. The application they built has made managing orders and customer interactions much easier and more efficient. We couldn’t be happier with the results and highly recommend their services to anyone in need of tech solutions. {" "}
                        <i className="fas fa-quote-right" />
                      </p>
                      <div className="rating">
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <div className="testimonial-content">
                      <div className="quote">
                        <i className="fas fa-quote-left" />
                      </div>
                      <div className="client-info">
                        <div className="client-pic">
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/tom.png"
                            }
                            alt="images"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Tom Fitzgerald</h4>
                          <span>Game Producer</span>
                        </div>
                      </div>
                      <p>
                        <i className="fas fa-quote-left" />Gybits delivered exceptionally high-quality graphics through their graphic development services. Their professionalism, creativity, and attention to detail exceeded our expectations, and we’re extremely satisfied with the results and overall service. {" "}
                        <i className="fas fa-quote-right" />
                      </p>
                      <div className="rating">
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <div className="testimonial-content">
                      <div className="quote">
                        <i className="fas fa-quote-left" />
                      </div>
                      <div className="client-info">
                        <div className="client-pic">
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/Shiva.png"
                            }
                            alt="images"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Shiva</h4>
                          <span>Founder & CEO </span>
                        </div>
                      </div>
                      <p>
                        <i className="fas fa-quote-left" />Gybits designed a modern and professional website for our healthcare business 
                        that clearly communicates our services and value. The platform highlights our 
                        expertise in revenue cycle management, credentialing, and billing in a clean 
                        and structured way. Their team understood our requirements well and delivered 
                        a fast, user-friendly website that has strengthened our online presence{" "}
                        <i className="fas fa-quote-right" />
                      </p>
                      <div className="rating">
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <div className="testimonial-content">
                      <div className="quote">
                        <i className="fas fa-quote-left" />
                      </div>
                      <div className="client-info">
                        <div className="client-pic">
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/Mansi.png"
                            }
                            alt="images"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Mansi Meena</h4>
                          <span>Managing Director</span>
                        </div>
                      </div>
                      <p>
                        <i className="fas fa-quote-left" />Gybits developed a powerful LinkedIn automation tool that has significantly 
                        improved our lead generation process. From automated connections to messaging 
                        and content posting, everything works smoothly and saves us a lot of time. 
                        The system is efficient, easy to use, and has helped us scale our outreach 
                        effectively.{" "}
                        <i className="fas fa-quote-right" />
                      </p>
                      <div className="rating">
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
                <div className="swiper-button-next" />
                <div className="swiper-button-prev" />
                <div className="swiper-pagination" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TestimonialArea;
